<template>
  <div :class="isGray ? 'wrapperImg' : ''">
    <BANNER></BANNER>
    <!-- 搜索模块  -->
    <SEARCHBLOCK></SEARCHBLOCK>
    <!-- 功能模块 -->
    <FUNCTIONBLOCK></FUNCTIONBLOCK>
    <!--党建专栏 盛京看点 媒体看盛京  -->
    <WATCHBLOCK></WATCHBLOCK>
    <!-- 国家临床重点专科 特色  -->
    <section class="medical-treatment blue-bg">
      <div class="container-width">
        <div class="item" @click="handleEmphasis">
          <div class="line-one">
            <p>国家临床重点专科</p>
            <p>NATIONAL KEY CLINICAL SPECIALTY</p>
          </div>
          <p class="line-two">查看更多</p>
        </div>
        <div class="item" @click="handleFeature">
          <div class="line-one">
            <p>特色医疗中心</p>
            <p>SPECIALTY MEDICAL CENTER</p>
          </div>
          <p class="line-two">查看更多</p>
        </div>
        <!-- <div class="item" @click="handlePostpartum">
          <div class="line-one">
            <p>溪月谷产后康复中心</p>
            <p>母婴至上、爱心、诚信第一</p>
          </div>
          <p class="line-two">点击进入</p>
        </div> -->
      </div>
    </section>
    <!-- news-block -->
    <section class="news-block container-width">
      <div class="news-left mt50">
        <div class="flex">
          <ul class="gg">
            <li class="on l_xx">
              <a>医院公告</a>
            </li>
            <li class="l_xx">
              <a class="" v-if="DWIDTH">招标与产品论证公告</a>
              <a v-if="!DWIDTH">招标与产..</a>
            </li>
            <li class="l_xx">
              <a v-if="DWIDTH">预决算专栏</a>
              <a v-if="!DWIDTH">预决算专..</a>
            </li>
          </ul>
          <a class="b-more" href="/sjkd/yygg">{{
            DWIDTH ? "查看更多" : "更多"
          }}</a>
          <a class="b-more" href="/sjkd/zbgg" style="display: none">{{
            DWIDTH ? "查看更多" : "更多"
          }}</a>
          <a class="b-more" href="/sjkd/yjszl" style="display: none">{{
            DWIDTH ? "查看更多" : "更多"
          }}</a>
        </div>
        <ul class="xx1_lb" style="width: 100%">
          <li
            v-for="(item, index) in yyggData"
            :key="index"
            @click="handleyyggArticle(item)"
          >
            <a :title="item.title">{{ item.title }}</a>
            <span class="zt_9d">{{ item.releaseDate }}</span>
          </li>
        </ul>
        <ul class="xx1_lb" style="display: none; width: 100%">
          <li
            v-for="(item, index) in zbggData"
            :key="index"
            @click="gozbArticle(item)"
          >
            <a :title="item.title">{{ item.title }}</a>
            <span class="zt_9d">{{ item.releaseDate }}</span>
          </li>
        </ul>
        <ul class="xx1_lb" style="display: none; width: 100%">
          <li
            v-for="(item, index) in yjszlData"
            :key="index"
            @click="handleYjszlArticle(item)"
          >
            <a :title="item.title">{{ item.title }}</a>
            <span class="zt_9d">{{ item.releaseDate }}</span>
          </li>
        </ul>
      </div>
      <div class="news-right mt50">
        <div class="flex">
          <ul class="gg">
            <li class="on l_aa">
              <a>医疗纵横</a>
            </li>
            <li class="l_aa">
              <a>健康教育</a>
            </li>
          </ul>
          <a class="aa1_more" href="/sjkd/ylzh">{{
            DWIDTH ? "查看更多" : "更多"
          }}</a>
          <a class="aa1_more" style="display: none" href="/jkjy">{{
            DWIDTH ? "查看更多" : "更多"
          }}</a>
        </div>
        <ul class="aa1_lb">
          <li
            v-for="(item, index) in ylzhData"
            :key="index"
            @click="goylzhArticle(item)"
          >
            <a :title="item.title">{{ item.title }}</a>
            <span class="zt_9d">{{ item.releaseDate }}</span>
          </li>
        </ul>
        <ul class="aa1_lb" style="display: none">
          <li
            v-for="(item, index) in jkjyData"
            :key="index"
            @click="gojkjyArticle(item)"
          >
            <a :title="item.title">{{ item.title }}</a>
            <span class="zt_9d">{{ item.releaseDate }}</span>
          </li>
        </ul>
      </div>
    </section>
    <!-- 盛京医讯 盛京TV   -->
    <section class="medicine-block container-width mb50">
      <div class="medicine-left mt50">
        <div class="column-block">
          <span class="column-title">盛京医讯</span>
        </div>
        <div class="medicine-body">
          <div class="img-list">
            <img src="@/assets/image/yx1.png" />
          </div>
          <div class="news-list">
            <div
              class="item"
              v-for="(item, index) in informationData"
              :key="index"
              @click="handleInfo(item)"
            >
              <div class="l">{{ item.title }}</div>
              <div class="r">【{{ item.releaseDate }}】</div>
            </div>
          </div>
        </div>
      </div>
      <div class="medicine-right mt50">
        <div class="column-block">
          <span class="column-title">盛京TV</span>
          <a class="aa1_more" href="/sjwh/tv">{{
            DWIDTH ? "查看更多" : "更多"
          }}</a>
        </div>
        <div
          class="choose-center"
          :style="{ backgroundImage: 'url(' + tvData.img + ')' }"
        >
          <div class="video-image">
            <div class="promo-video">
              <div class="waves-block">
                <div class="waves wave-1"></div>
                <div class="waves wave-2"></div>
                <div class="waves wave-3"></div>
              </div>
            </div>
            <!--/ End Video Animation -->
            <a href="/sjwh/tv" class="video">
              <img src="@/assets/image/play.png" />
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- 友情链接 -->
    <div class="friendship-block" :style="{ backgroundImage: `url(${imgss})` }">
      <div class="container-width">
        <div class="foot-links clearFix">
          <div class="x-wrap">
            <div class="foot-links-left clearFix">
              <div class="r-content">
                <a href="javascript:viod(0)">友情链接:</a>

                <a href="http://www.nhc.gov.cn/" target="_blank"
                  >国家卫生健康委员会</a
                >

                <a href="https://wsjk.ln.gov.cn/" target="_blank"
                  >辽宁省卫生健康委员会</a
                >

                <a href="https://www.cmu.edu.cn/" target="_blank"
                  >中国医科大学</a
                >
              </div>
            </div>
            <div class="foot-links-right">
              <div class="foot-links-item">
                <img src="@/assets/image/qrode2.png" />
                <p>微信订阅号</p>
              </div>
              <div class="foot-links-item">
                <img src="@/assets/image/qrode1.png" />
                <p>微信服务号</p>
              </div>
              <div class="foot-links-item">
                <img src="@/assets/image/qrode3.png" />
                <p>手机APP</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import service from "../../service/index";
import config from "../../config/dev";
import BANNER from "../../components/banner/home";
import SEARCHBLOCK from "../../components/index/search";
import FUNCTIONBLOCK from "../../components/index/function";
import WATCHBLOCK from "../../components/index/watch";
import imgss from "@/assets/image/bg/bg2.jpg";
// import Search from '../ylts/search.vue';
export default {
  name: "HOME",
  data() {
    return {
      yyggData: [],
      yjszlData: [],

      ylzhData: [],
      jkjyData: [],
      zbggData: [],
      ztjyData: [],
      tvData: {},
      informationData: [],
      isGray: false, // 首页是否置灰
      disease: "", // 查询疾病
      imgss: imgss, //友情链接背景图
      DWIDTH: false, // 移动端适配
      // windowHeight: document.body.clientHeight,
      windowWidth: document.body.clientWidth,
    };
  },
  components: {
    BANNER,
    SEARCHBLOCK,
    FUNCTIONBLOCK,
    WATCHBLOCK,
  },
  computed: {},
  created() {
    this.init();
    this.getGraySetting();
  },
  beforeMount() {},
  methods: {
    init() {
      // 医院公告数据
      this.getNoticeData();
      // 招标公告
      this.getZhaobiaoData();
      // 预决算专栏数据
      this.getYujusuanData();
      // 医疗纵横数据
      this.getYiliaozonghengData();
      // 健康教育数据
      this.getJiankangjiaoyuData();
      // 盛京医讯数据
      this.getShengJingYiXunData();
      // 盛京TV 数据
      this.getTVData();
    },

    // 医院公告数据
    getNoticeData() {
      let parmes = {
        pageIndex: 1,
        pageSize: 5,
        isshow: "1",
        issuggest: "1",
      };
      service.getwzHospitalNoticeList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.releaseDate = item.releaseDate.split(" ")[0] || "";
          });
        }
        this.yyggData = res.content || [];
      });
    },
    //医院公告 文章
    handleyyggArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: `/sjkd/yygg/article`,
          query: {
            id: e.id,
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    // 招标公告数据
    getZhaobiaoData() {
      let parmes = {
        pageIndex: 1,
        pageSize: 5,
        isshow: "1",
        issuggest: "1",
      };
      service.getwzBiddingNoticeList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.releaseDate = item.releaseDate.split(" ")[0] || "";
          });
        }
        this.zbggData = res.content || [];
      });
    },
    // 招标文章
    gozbArticle(e) {
      if (e.type == 1) {
        let routeUrl = this.$router.resolve({
          path: `/sjkd/zbgg/article/zb`,
          query: {
            id: e.id,
          },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: `sjkd/zbgg/article/cp`,
          query: {
            id: e.id,
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    // 预决算专栏数据
    getYujusuanData() {
      let parmes = {
        pageIndex: 1,
        pageSize: 6,
        isshow: "1",
        issuggest: "1",
      };
      service.getpreComputation(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.releaseDate = item.releaseDate.split(" ")[0] || "";
          });
        }
        this.yjszlData = res.content || [];
      });
    },
    // 预决算专栏 文章
    handleYjszlArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: `/sjkd/yjszl/article`,
          query: {
            id: e.id,
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    // 医疗纵横数据
    getYiliaozonghengData() {
      let parmes = {
        pageIndex: 1,
        pageSize: 5,
        isshow: "1",
        issuggest: "1",
      };
      service.getwzMedicalAffairsList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.releaseDate = item.releaseDate.split(" ")[0] || "";
          });
        }
        this.ylzhData = res.content || [];
      });
    },
    // 医疗纵横 文章
    goylzhArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let articleId = e.id;
        const { href } = this.$router.resolve({
          path: `/sjkd/ylzh/article/${articleId}`,
        });
        window.open(href, "_blank");
      }
    },
    // 健康教育 数据
    getJiankangjiaoyuData() {
      service.getChannelList(
        {
          isshow: "1",
        },
        (res) => {
          this.channel = res.content.find((item) => {
            if (item.name == "内科") {
              return item;
            }
          });
          this.getChannelInfoList();
        }
      );
    },
    // 健康教育 数据
    getChannelInfoList() {
      let parmes = {
        channelId: this.channel.id,
        pageIndex: 1,
        pageSize: 5,
        isshow: "1",
      };
      service.getChannelInfoList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.releaseDate = item.releaseDate
              ? item.releaseDate.substr(0, 10)
              : "";
          });
        }
        this.jkjyData = res.content || [];
      });
    },
    // 健康教育 文章
    gojkjyArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        this.$router.push({
          path: `/jkjy/article`,
          query: {
            id: e.id,
            channelName: "内科",
          },
        });
      }
    },
    // 盛京医讯数据
    getShengJingYiXunData() {
      let parmes = {
        pageIndex: 1,
        pageSize: 5,
        isshow: "1",
        issuggest: "1",
      };
      service.getwzSjMedicalInformationList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.releaseDate = item.releaseDate.split(" ")[0] || "";
          });
        }
        this.informationData = res.content;
      });
    },
    // 盛京医讯文章
    handleInfo(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: `/sjwh/zhoukan/list`,
          query: {
            id: e.id,
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    // 盛京TV 数据
    getTVData() {
      let parmes = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isshow: 1,
        currentYear: this.currentYear,
      };
      service.getwzTvList(parmes, (res) => {
        res.content.map((item) => {
          item.img =
            config.url + "/file/downloadFile/" + item.img + "?isDownload=true";
        });
        this.tvData = { ...res.content[0] } || {};
      });
    },

    // 收否开启了置灰
    getGraySetting() {
      service.setIndexGray({}, (res) => {
        this.isGray = res;
      });
    },
    // 搜索症状/疾病
    handleSearchDisease() {
      let searchContent = this.disease;
      const { href } = this.$router.resolve({
        path: `/ylts/search`,
        query: {
          type: "disease",
          searchContent: `${searchContent}`,
        },
      });
      window.open(href, "_blank");
    },

    // 国家临床重点专科
    handleEmphasis() {
      const { href } = this.$router.resolve({
        path: `/ylts/zhuanke`,
      });
      window.open(href, "_self");
    },
    // 特色医疗中心
    handleFeature() {
      const { href } = this.$router.resolve({
        path: `/ylts/tese`,
      });
      window.open(href, "_self");
    },
    // 溪月谷产后康复中心
    // handlePostpartum() {
    //   window.open("http://xiyuegu.sj-hospital.org/", "_blank");
    // },
  },
  mounted() {
    $(function () {
      // 医院公告
      $(".kd_xx").click(function () {
        $(this).addClass("on");
        $(this).siblings().removeClass("on");
        var index = $(this).index();
        $(".kd_lb").hide().eq(index).show();
        $(".kd_more").hide().eq(index).show();
      });
      // 医院公告
      $(".l_xx").click(function () {
        $(this).addClass("on");
        $(this).siblings().removeClass("on");
        var index = $(this).index();
        $(".xx1_lb").hide().eq(index).show();
        $(".b-more").hide().eq(index).show();
      });
      // 医疗纵横
      $(".l_aa").click(function () {
        $(this).addClass("on");
        $(this).siblings().removeClass("on");
        var index = $(this).index();
        $(".aa1_lb").hide().eq(index).show();
        $(".aa1_more").hide().eq(index).show();
      });
    });
    // if (window.screen.width < 600) {
    //   this.DWIDTH = false;
    // } else {
    //   this.DWIDTH = true;
    // }
    // <!--把window.onresize事件挂在到mounted函数上-->
    window.onresize = () => {
      return (() => {
        // this.windowHeight = document.documentElement.clientHeight; // 高
        this.windowWidth = document.documentElement.clientWidth; // 宽
      })();
    };
  },
  watch: {
    // 监听页面高度
    // windowHeight(val) {
    //   console.log("实时屏幕高度：", val, this.windowHeight);
    //   if (val < 600) {
    //     this.DWIDTH = false;
    //   } else {
    //     this.DWIDTH = true;
    //   }
    // },
    // 监听页面宽度
    windowWidth(val) {
      if (val < 620) {
        this.DWIDTH = false;
      } else {
        this.DWIDTH = true;
      }
    },
  },
};
</script>


<style scoped lang="scss">
// 首页置灰相关
.isGray {
  -webkit-filter: grayscale(100%);
  filter: Gray;
}

// end

@keyframes rot {
  0% {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
  25% {
    transform: rotate(5deg);
    -webkit-transform: rotate(5deg);
  }
  50% {
    transform: rotate(-5deg);
    -webkit-transform: rotate(-5deg);
  }
  75% {
    transform: rotate(5deg);
    -webkit-transform: rotate(5deg);
  }
  100% {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
}

@-webkit-keyframes rot {
  0% {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
  25% {
    transform: rotate(5deg);
    -webkit-transform: rotate(5deg);
  }
  50% {
    transform: rotate(-5deg);
    -webkit-transform: rotate(-5deg);
  }
  75% {
    transform: rotate(5deg);
    -webkit-transform: rotate(5deg);
  }
  100% {
    transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
  }
}

// end

/* end */
.column-block {
  height: 42px;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.column-title {
  float: left;
  font-size: 1.6rem;
  position: relative;
  margin-right: auto;
  border-bottom: 4px solid #004d9e;
}

.news-block {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -moz-flex-direction: column;
  -webkit-flex-direction: column;
  flex-direction: column;
}
.news-left {
  width: 100%;
  padding-right: 20px;
  flex: 1;
}
.news-right {
  width: 100%;
  flex: 1;
}

.news-left .flex,
.news-right .flex {
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.medicine-block {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  .medicine-left {
    flex: 1;
    box-sizing: border-box;
    // -webkit-box-shadow: 0px 0px 24px 0px rgba(2, 2, 2, 0.05);
    // box-shadow: 0px 0px 24px 0px rgba(2, 2, 2, 0.05);
    // padding: 25px 25px;
    // box-sizing: border-box;
    // height: 386px;
    border-radius: 5px;

    .medicine-body {
      -webkit-box-shadow: 0px 0px 24px 0px rgba(2, 2, 2, 0.05);
      box-shadow: 0px 0px 24px 0px rgba(2, 2, 2, 0.05);
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      margin-top: 30px;
      // height: 220px;
      overflow: hidden;
      .img-list {
        /* margin-top: 32px; */
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        -ms-flex-pack: justify;
        justify-content: space-between;
        max-width: 30%;

        img {
          max-width: 100%;
          max-height: 100%;
          cursor: pointer;
        }
      }
      .news-list {
        flex: 1;
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -moz-flex-direction: column;
        -webkit-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: justify;
        -webkit-justify-content: space-between;
        -ms-flex-pack: justify;
        justify-content: space-between;
        // padding: 0 20px 30px 20px;
        padding: 0 10px;
        box-sizing: border-box;
        .item {
          display: -webkit-box;
          display: -moz-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -webkit-justify-content: center;
          justify-content: space-between;
          -webkit-box-align: center;
          -webkit-align-items: center;
          -ms-flex-align: center;
          align-items: center;
          cursor: pointer;
          border-bottom: solid 1px #eee;
          flex: 1;
          position: relative;
          // padding-left: 20px;

          div {
            font-size: 1rem;
          }
        }
        .item:before {
          content: "";
          position: absolute;
          width: 6px;
          height: 6px;
          background: #00479d;
          left: 7px;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
  .medicine-right {
    width: 645px;
    margin-left: 40px;
    // -webkit-box-shadow: 0px 0px 24px 0px rgba(2, 2, 2, 0.05);
    // box-shadow: 0px 0px 24px 0px rgba(2, 2, 2, 0.05);
    // padding: 25px 25px;
    // box-sizing: border-box;
    flex: 1;
    height: 386px;
    background-color: #fff;
    border-radius: 5px;
    .choose-center {
      flex: 1;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      position: relative;
      height: 220px;
      margin-top: 30px;
      -webkit-box-shadow: 0px 0px 24px 0px rgba(2, 2, 2, 0.05);
      box-shadow: 0px 0px 24px 0px rgba(2, 2, 2, 0.05);
      padding: 25px 25px;
      box-sizing: border-box;
    }
  }
}

.medicine-block .container-width div:last-child {
  margin-right: 0%;
}

.video-image .waves-block .waves {
  position: absolute;
  width: 200px;
  height: 200px;
  background: #fff;
  opacity: 0;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  border-radius: 100%;
  -webkit-animation: waves 3s ease-in-out infinite;
  animation: waves 3s ease-in-out infinite;
  left: 50%;
  margin-left: -100px;
  top: 50%;
  margin-top: -100px;
}

.video-image .waves-block .wave-1 {
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}

.video-image .waves-block .wave-2 {
  -webkit-animation-delay: 1s;
  animation-delay: 1s;
}

.video-image .waves-block .wave-3 {
  -webkit-animation-delay: 2s;
  animation-delay: 2s;
}

.video {
  background: #00479d !important;
}

.video {
  color: #fff;
  height: 70px;
  width: 70px;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
  justify-content: center;

  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  border-radius: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -35px;
  margin-top: -35px;
  font-size: 21px;
  background: #1a76d1;
  padding-left: 4px;
}

.video img {
  width: 30px;
  height: 30px;
}

.choose-center .video:hover {
  transform: scale(1.1);
}

.why-choose .video-image .waves-block .waves {
  position: absolute;
  width: 200px;
  height: 200px;
  background: #fff;
  opacity: 0;
  -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  border-radius: 100%;
  -webkit-animation: waves 3s ease-in-out infinite;
  animation: waves 3s ease-in-out infinite;
  left: 50%;
  margin-left: -100px;
  top: 50%;
  margin-top: -100px;
}

.why-choose .video-image .waves-block .wave-1 {
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}

.why-choose .video-image .waves-block .wave-2 {
  -webkit-animation-delay: 1s;
  animation-delay: 1s;
}

.why-choose .video-image .waves-block .wave-3 {
  -webkit-animation-delay: 2s;
  animation-delay: 2s;
}

@-webkit-keyframes waves {
  0% {
    -webkit-transform: scale(0.2, 0.2);
    transform: scale(0.2, 0.2);
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  }
  50% {
    opacity: 0.9;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=90)";
  }
  100% {
    -webkit-transform: scale(0.9, 0.9);
    transform: scale(0.9, 0.9);
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  }
}

@keyframes waves {
  0% {
    -webkit-transform: scale(0.2, 0.2);
    transform: scale(0.2, 0.2);
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  }
  50% {
    opacity: 0.9;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=90)";
  }
  100% {
    -webkit-transform: scale(0.9, 0.9);
    transform: scale(0.9, 0.9);
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
  }
}

// footer
.x-wrap {
  padding: 50px 0 80px;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
}

.foot-links-left {
  width: 800px;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  .r-content {
    display: -webkit-flex;
    display: flex;
    flex-wrap: wrap;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
    margin-top: 30px;
    a {
      margin-right: 15px;
      font-size: 1.4rem;
      color: #0f4469;
    }
    // a:first-child {
    //   width: 120px;
    // }
  }
}
.foot-links-right {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: flex-end;
  flex: 1;
  .foot-links-item {
    position: relative;
    width: 100px;
    height: 100px;
    margin-right: 20px;

    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100px;
      // height: 100px;
      margin: 0;
    }
    p {
      width: 100%;
      text-align: center;
      position: absolute;
      top: 110px;
      font-size: 1rem;
    }
  }
  &:last-child {
    margin-right: 0px;
  }
}

@media only screen and (max-width: 1200px) {
  .news-block {
    padding: 0 10px;
    box-sizing: border-box;
    .news-left {
      width: 100%;
      padding-right: 0;
    }
    .news-right {
      width: 100%;
      padding-top: 20px;
      background: #f6fbff;
      margin-top: 0;

      padding-left: 2vw;
      padding-right: 2vw;
      box-sizing: border-box;
    }
    .column-title {
      font-size: 1rem;
    }
  }
  .medicine-block {
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
    padding: 0 10px;
    box-sizing: border-box;
    .container-width {
      display: -webkit-flex;
      display: flex;
      -moz-flex-direction: column;
      -webkit-flex-direction: column;
      flex-direction: column;
    }
    .img-list {
      width: 38%;
      -webkit-justify-content: center;
      justify-content: center;

      // margin: 15px auto 0;
      img {
        width: 90%;
        height: auto;
      }
    }

    .medicine-body {
      height: auto;
      padding: 10px 5px;
      box-sizing: border-box;
      margin-top: 20px;
      .news-list {
        padding: 0;
        .item {
          height: 40px;
          line-height: 40px;
          padding-left: 0;
        }
        .item::before {
          display: none;
        }
      }
    }
    .medicine-right {
      width: 100%;
      margin-left: 0;
      margin-top: 20px;
    }
  }
  .x-wrap {
    flex-direction: column;
    padding: 10px;
  }
  .column-title {
    font-size: 1.2rem;
  }

  .video-image .waves-block .waves {
    position: absolute;
    width: 100px;
    height: 100px;
    background: #fff;
    opacity: 0;
    -ms-filter: "progid:DXImageTransform.Microsoft.Alpha(Opacity=0)";
    border-radius: 100%;
    -webkit-animation: waves 3s ease-in-out infinite;
    animation: waves 3s ease-in-out infinite;
    left: 50%;
    margin-left: -50px;
    top: 50%;
    margin-top: -50px;
  }
  .video {
    height: 40px;
    width: 40px;
    margin-left: -20px;
    margin-top: -20px;
  }
  .medicine-left .news-list .item div {
    font-size: 1rem;
  }
  .medicine-left .news-list .item .r {
    font-size: 12px;
  }
  .foot-links-right {
    margin-top: 20px;
    justify-content: space-around;
    .foot-links-item {
      margin-right: 5px;
    }
  }
  .foot-links-left {
    width: 100%;
    .r-content {
      margin-top: 20px;
      flex-direction: column;
      justify-content: flex-start;
      align-items: baseline;
      a {
        font-size: 1.2rem;
      }
    }
  }
}
@media only screen and (min-width: 1200px) {
  .medicine-left {
    .news-list {
      .item {
        flex-direction: row;
        justify-content: space-between;
        padding-left: 20px;
        div {
          font-size: 16px;
        }
      }
    }
  }
  .news-left {
    width: 49%;
  }
  .news-right {
    width: 49%;
  }

  .medicine-block {
    padding: 25px 25px;
  }
}
@media only screen and (min-width: 1200px) {
  .news-block {
    -moz-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: row;
  }
}

.w28 {
  width: 28%;
}
// start====================== //

/* 国家临床重点专科 特色  */
// .medical-treatment {
//   width: 100%;
//   padding: 50px 0;
//   margin-top: 50px;
//   .container-width {
//     display: -webkit-box;
//     display: -moz-box;
//     display: -ms-flexbox;
//     display: -webkit-flex;
//     display: flex;
//     height: 200px;
//     .item {
//       flex: 1;
//       color: #fff;
//       padding: 20px 25px;
//       display: -webkit-box;
//       display: -moz-box;
//       display: -ms-flexbox;
//       display: -webkit-flex;
//       display: flex;
//       -webkit-box-pack: justify;
//       -webkit-justify-content: space-between;
//       -ms-flex-pack: justify;
//       justify-content: space-between;
//       -moz-flex-direction: column;
//       -webkit-flex-direction: column;
//       flex-direction: column;
//       -webkit-box-align: center;
//       -webkit-align-items: center;
//       -ms-flex-align: center;
//       align-items: center;
//       box-sizing: border-box;
//       cursor: pointer;
//       .line-one {
//         p:nth-child(1) {
//           font-size: 1rem;
//           letter-spacing: 3px;
//           transition: all 0.2s linear;
//         }
//         p:nth-child(1):hover {
//           letter-spacing: 6px;
//           transition: all 0.2s linear;
//         }
//         p:nth-child(2) {
//           font-size: 12px;
//           text-align: center;
//         }
//       }
//     }
//     .item:nth-child(1) {
//       background-color: #00479d;
//       margin-right: 2%;
//     }
//     .item:nth-child(2) {
//       background-color: #842331;
//       margin-right: 2%;
//     }
//     .item:nth-child(3) {
//       background-color: #829c05;
//     }
//   }
//   a {
//     color: #ffffff;
//   }
// }
.medical-treatment {
  width: 100%;
  padding: 20px 0;
  margin-top: 20px;
  .container-width {
    padding: 0 10px;
    height: 125px;
    box-sizing: border-box;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    // height: 200px;
    .item {
      padding: 20px 0px;
      // padding: 20px 25px;
      box-sizing: border-box;
      flex: 1;
      color: #fff;
      display: -webkit-box;
      display: -moz-box;
      display: -ms-flexbox;
      display: -webkit-flex;
      display: flex;
      -webkit-box-pack: justify;
      -webkit-justify-content: space-between;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -moz-flex-direction: column;
      -webkit-flex-direction: column;
      flex-direction: column;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      box-sizing: border-box;
      cursor: pointer;
      width: 100%;
      .line-one {
        width: 100%;
        p:nth-child(1) {
          letter-spacing: px;
          transition: all 0.2s linear;
          text-align: center;
          width: 85%;
          margin-left: 7.5%;
          text-align: center;
          font-size: 1rem;
          letter-spacing: 3px;
          transition: all 0.2s linear;
        }

        p:nth-child(1):hover {
          // letter-spacing: 6px;
        }
        p:nth-child(2) {
          font-size: 12px;
          text-align: center;
          display: none;
        }
      }
    }
    .item:nth-child(1) {
      background-color: #00479d;
      margin-right: 2%;
    }
    .item:nth-child(2) {
      background-color: #842331;
      margin-right: 2%;
    }
    .item:nth-child(3) {
      background-color: #829c05;
    }
  }
}

/* 小屏幕（平板，大于等于 420px） */
@media only screen and (max-width: 420px) {
  .medicine-block {
    .medicine-left {
      .medicine-body {
        .img-list {
          img {
            width: 100px;
            height: 110px;
          }
        }
        .news-list {
          padding: 0 10px 10px 0px;
          .item {
            // flex-direction: column;
            align-items: flex-start;
            justify-content: space-between;
            line-height: 24px;
            height: 24px;
            padding: 0 10px;
          }
        }
      }
    }

    // .medicine-right {
    //   .choose-center {

    //   }
    // }
  }
}

/* 小屏幕（平板，大于等于 420px） */
.medical-treatment {
  .container-width {
    height: 150px;
    // height: 200px;
    .item {
      padding: 20px 5px;
      // padding: 20px 25px;

      .line-one {
        p:nth-child(1) {
          font-size: 1.2rem;
          letter-spacing: 3px;
          transition: all 0.2s linear;
        }
        p:nth-child(1):hover {
          // letter-spacing: 6px;
        }
        p:nth-child(2) {
          font-size: 12px;
          text-align: center;
        }
      }
    }
  }
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media only screen and (min-width: 992px) {
  .medical-treatment {
    .container-width {
      height: 160px;
      // height: 200px;
      .item {
        padding: 20px 10px;
        // padding: 20px 25px;

        .line-one {
          p:nth-child(1) {
            font-size: 1.2rem;
            letter-spacing: 3px;
          }
          p:nth-child(1):hover {
            // letter-spacing: 6px;
          }
          p:nth-child(2) {
            font-size: 0.9rem;
            text-align: center;
            display: block;
          }
        }
      }
    }
  }
}

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media only screen and (min-width: 1200px) {
}

/* 小屏幕（大桌面显示器 大于等于 1330px） */
@media only screen and (min-width: 1330px) {
  .medical-treatment {
    .container-width {
      height: 180px;
      // height: 200px;
      .item {
        padding: 20px 10px;
        // padding: 20px 25px;

        .line-one {
          p:nth-child(1) {
            font-size: 1.4rem;
            letter-spacing: 3px;
          }
          p:nth-child(1):hover {
            // letter-spacing: 6px;
          }
          p:nth-child(2) {
            font-size: 1rem;
            text-align: center;
            display: block;
          }
        }
      }
    }
  }
  .medicine-block {
    .medicine-left {
      .medicine-body {
        height: 336px;
        .news-list {
          padding: 0 20px 30px 20px;
          .item {
            padding-left: 20px;
            justify-content: space-between;
            .l {
              font-size: 16px;
            }
            .r {
              font-size: 16px;
            }
          }
        }
      }
    }

    .medicine-right {
      .choose-center {
        height: 336px;
      }
    }
  }
}

/* 小屏幕（大桌面显示器 大于等于 1900px） */
@media only screen and (min-width: 1900px) {
  .medical-treatment {
    .container-width {
      height: 200px;
      .item {
        padding: 20px 25px;

        .line-one {
          p:nth-child(1) {
            font-size: 1.6rem;
            letter-spacing: 3px;
          }
          p:nth-child(1):hover {
            letter-spacing: 6px;
          }
          p:nth-child(2) {
            font-size: 1rem;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
